import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_Search } from 'ui/components/3-organisms/Search/Search';
import { useState } from 'react';
import { useAuthenticationContext } from '3-foundation/Authentication/AuthenticationContext';
import { getSearchResults } from '3-foundation/Search/repository';
import useSWR from 'swr';
import { BlurbCardProps } from 'ui/components/2-molecules/Card/BlurbCard/BlurbCard';
import { useApplicationContext } from '3-foundation/Application/ApplicationContext';

const searchResultMapper = (item: Search.SearchResult): BlurbCardProps => {
	const { url, snippet, title } = item ?? {};

	return {
		link: { url: url?.raw },
		heading: title,
		text: snippet?.html,
	};
};

export const Search = () => {
	const dictionary = useDictionaryContext();
	const auth = useAuthenticationContext();
	const application = useApplicationContext();

	const searchUrl = application?.envVars?.SEARCH_API_URL;

	const [searchQuery, setSearchQuery] = useState('');

	const shouldSearch = searchQuery !== '';

	const fetcher = () => getSearchResults(searchUrl, searchQuery, auth.accessToken);
	const { data, error, isLoading } = useSWR(shouldSearch ? [searchUrl, searchQuery, auth.accessToken] : null, fetcher, {
		revalidateOnFocus: false,
	});

	const { numberOfResults, query, searchResults = [] } = data ?? {};

	const mappedResults: BlurbCardProps[] = searchResults.map((result) => searchResultMapper(result));

	return (
		<UI_Search
			searchButtonText={dictionary.getSearch('Search')}
			searchInputPlaceholder={dictionary.getSearch('EnterKeyword')}
			requiredFieldErrorMessage={dictionary.getSearch('RequiredField')}
			searchResultText={dictionary.getSearch('FoundNumberOfResultsFrom')}
			searchErrorText={dictionary.getSearch('ErrorOccurred')}
			getSearchResults={(query: string) => setSearchQuery(query)}
			isLoading={shouldSearch && isLoading}
			error={error}
			searchResult={{
				numberOfResults,
				query,
				results: mappedResults,
			}}
		/>
	);
};
